import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UpUser = function (_NebulaModuleBase) {
    _inherits(UpUser, _NebulaModuleBase);

    function UpUser() {
        _classCallCheck(this, UpUser);

        return _possibleConstructorReturn(this, (UpUser.__proto__ || Object.getPrototypeOf(UpUser)).apply(this, arguments));
    }

    _createClass(UpUser, [{
        key: 'socialLogin',
        value: function socialLogin(data) {
            var pluginName = 'socialLoginForUmPlugin';
            if (data.platform === 'facebook') {
                pluginName = 'facebookForFacebookPlugin';
            }
            return this.generatePromiseByFunctionWithParams(pluginName, data);
        }
    }, {
        key: 'checkAppIsInstalled',
        value: function checkAppIsInstalled(data) {
            return this.generatePromiseByFunctionWithParams('checkAppIsInstalledForUmPlugin', data);
        }
    }, {
        key: 'getLoginStatus',
        value: function getLoginStatus() {
            return this.generatePromiseByFunctionWithParams('getLoginStatusForUser', {});
        }
    }, {
        key: 'getUserInfo',
        value: function getUserInfo() {
            return this.generatePromiseByFunctionWithParams('getUserInfoForUser', {});
        }
    }, {
        key: 'updateOauthData',
        value: function updateOauthData(data) {
            return this.generatePromiseByFunctionWithParams('updateOauthDataForUser', data);
        }
    }, {
        key: 'updateUserInfo',
        value: function updateUserInfo(data) {
            return this.generatePromiseByFunctionWithParams('updateUserInfoForUser', data);
        }
    }, {
        key: 'getOauthData',
        value: function getOauthData() {
            return this.generatePromiseByFunctionWithParams('getOauthDataForUser', {});
        }
    }, {
        key: 'refreshUser',
        value: function refreshUser() {
            return this.generatePromiseByFunctionWithParams('refreshUserForUser', {});
        }
    }, {
        key: 'logOut',
        value: function logOut() {
            return this.generatePromiseByFunctionWithParams('logOutForUser', {});
        }
    }, {
        key: 'getQQMusicAuthorize',
        value: function getQQMusicAuthorize() {
            return this.generatePromiseByFunctionWithParams('qqMusicAuthForQQMusicPlugin', {});
        }
    }, {
        key: 'cancelLogin',
        value: function cancelLogin() {
            return this.generatePromiseByFunctionWithParams('cancelLogin', {});
        }
    }]);

    return UpUser;
}(NebulaModuleBase);